import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountAPI } from '../../apis/account-api';
// import { usePublicAPI } from '../../apis/public-api';
import { OAuthModalBody } from '../../components/auth/oauth-modal-body';
import { useErrorHandler } from '../../hooks/use-error-handler';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useMenuManager } from '../../utils/manager/menu-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { OAuthModalTitle } from '../../components/auth/oauth-modal-title';
import { usePublicAPI } from '../../apis/public-api';

function useOAuthModal() {
  const analytics = useAnalytics();
  const { analyticsPageView, analyticsFeatureUseEvent } = useAnalytics();
  const { configRef } = useStorage();
  const storage = useStorage();
  const { swal } = useSwal({ storage });
  const { spotRef, setUser } = storage;
  const accountAPI = useAccountAPI();
  // const publicAPI = usePublicAPI();
  const { loadMenu } = useMenuManager();
  const { handleErrorOnModal } = useErrorHandler();
  const { getLoginPrivacyPolicyFromRemote } = usePublicAPI();

  const didOpen = () => {
    analyticsPageView('OAuth');
  };

  const { t } = useTranslation();

  async function onOAuthLoggedIn(user, service, prepareOnPreConfirm) {
    analyticsFeatureUseEvent(`${service} auth logged in`);
    setUser(user);

    try {
      await prepareOnPreConfirm?.call(this);
      swal.clickConfirm();
    } catch (error) {
      handleErrorOnModal(error);
      swal.hideLoading();
    }
  }

  const onErrorMessage = (message, service) => {
    if (_.isEmpty(message)) {
      swal.resetValidationMessage();
    } else {
      analyticsFeatureUseEvent(`${service} auth failure`);
      swal.showValidationMessage(message);
    }
  };

  async function prepare() {
    try {
      await loadMenu();
    } catch (error) {
      console.error(error);
    }
  }

  async function show({ showName, prepareOnPreConfirm }) {
    const config = configRef.current;

    const result = await swal.fire({
      title: (
        <OAuthModalTitle
          analytics={analytics}
          getPrivacyPolicyFromRemote={getLoginPrivacyPolicyFromRemote}
        />
      ),
      html: (
        <OAuthModalBody
          analytics={analytics}
          accountAPI={accountAPI}
          // publicAPI={publicAPI}
          showNameParam={showName && !spotRef.current?.type?.addressable}
          config={config}
          onLoggedIn={(user, service) =>
            onOAuthLoggedIn(user, service, prepareOnPreConfirm)
          }
          onErrorMessage={onErrorMessage}
        />
      ),
      didOpen,
      inputAttributes: { autocapitalize: 'on', maxlength: 30 },
      // preConfirm: () => preConfirm({ prepareOnPreConfirm }),
      cancelButtonText: t('cancel'),
      showCancelButton: true,
      showConfirmButton: false,
      // showLoaderOnConfirm: true,
    });

    return result;
  }

  // async function preConfirm({ prepareOnPreConfirm }) {
  //   try {
  //     await prepareOnPreConfirm?.call(this);
  //   } catch (error) {
  //     handleErrorOnModal(error);
  //     swal.hideLoading();
  //     return false;
  //   }

  //   return true;
  // }

  return {
    prepareOAuthModal: prepare,
    showOAuthModal: show,
  };
}

export { useOAuthModal };
